import styles from './ViewOnStrava.module.css';

// Strava's brand guidelines fix this wording; the capitals come from CSS.
const VIEW_ON_STRAVA = 'View on Strava';

// className lays the link out where it sits; this module keeps it legible as a Strava link (orange, underlined).
export function ViewOnStrava({ href, className }: { href: string; className?: string }) {
  return <a href={href} target="_blank" rel="noopener" className={[styles.link, className].filter(Boolean).join(' ')}>{VIEW_ON_STRAVA}</a>;
}
